module.exports = __webpack_public_path__ + "img/agave_2.9e9dc655.jpeg";